import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModeloModel } from 'app/model/modelo/modelo.model';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

@Component({
  selector: 'app-manter-model',
  templateUrl: './manter-model.component.html',
  styleUrls: ['./manter-model.component.scss'],
})
export class ManterModelComponent implements OnInit {
  public cadastroModelo: FormGroup;
  public clientes: ClienteModel[];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public modeloEdit: ModeloModel;
  public disableForm = false;
  public buttonDisable = false;

  public novoModelo = true;

  public clientId;

  private authorityArray: string[];
  idCliente = {} as ClienteModel;

  public superUser = false;
  public addModelo = false;

  constructor(
    private fb: FormBuilder,
    private clienteService: ClienteService,
    private manterModelo: ConfigurarPastaServiceService,
    private _snackBar: MatSnackBar,
    private dialogoRef: MatDialogRef<ManterModelComponent>,
    private permissoesService: PermissoesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.cadastroModelo = this.fb.group({
      id: [''],
      description: [''],
      author: [''],
      name: ['', Validators.required],
      namespace: ['', Validators.required],
      prefix: ['', Validators.required],
      novo: [true],
      clientId: ['', Validators.required],
      isActive: [true],
    });
    this.listarClientesUsuario();
    this.modeloEdit = this.data.modelo;

    if (this.modeloEdit !== undefined && this.modeloEdit !== null) {
      this.novoModelo = false;
      this.disableForm = true;
      this.cadastroModelo.get('id').setValue(this.modeloEdit.id);
      this.preencherForm(this.modeloEdit);
    } else {
      // this.modeloEdit =
      this.disableForm = false;
      this.novoModelo = true;
    }
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  editSubmit() {
    this.manterModelo.putModelo(this.cadastroModelo.value).subscribe(
      (resultado) => {
        this.openSnackBarSuccess(' Modelo Editado com sucesso ! ');
        this.dialogoRef.close(true);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onSubmit() {
    this.manterModelo.postCriarModelo(this.cadastroModelo.value).subscribe(
      (result) => {
        this.openSnackBarSuccess(' Modelo alfresco salvo com sucesso ! ');
        this.dialogoRef.close(true);
      },
      (err) => {
        console.error(err);

        let arrayErrors = [];
        const erroAPI = err.error;
        const mensagens = [];
        let erroApiArray = [];

        if (erroAPI.errors != null) {
          erroApiArray = erroAPI.errors;
        } else {
          mensagens[0] = erroAPI.message;
        }
        if (erroApiArray.length > 0) {
          arrayErrors = erroApiArray;

          mensagens[0] = 'Campos obrigatórios não preenchidos';
        }

        this.openSnackBarError(mensagens.toString());
      }
    );
  }
  openSnackBarSuccess(message: string): void {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar'],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
  }

  preencherForm(modeloEdit) {
    this.cadastroModelo.get('description').setValue(modeloEdit.description);
    this.cadastroModelo.get('prefix').setValue(modeloEdit.prefix);
    this.cadastroModelo.get('name').setValue(modeloEdit.name);
    this.cadastroModelo.get('namespace').setValue(modeloEdit.namespace);
    this.cadastroModelo.get('author').setValue(modeloEdit.author);
    this.cadastroModelo.get('clientId').setValue(modeloEdit.clientId);

    this.cadastroModelo.get('namespace').disable();
    this.cadastroModelo.get('name').disable();
    this.cadastroModelo.get('prefix').disable();
    this.cadastroModelo.get('clientId').disable();
  }

  habilitarForm() {
    this.cadastroModelo.get('namespace').enable();
    this.cadastroModelo.get('name').enable();
    this.cadastroModelo.get('prefix').enable();
    this.cadastroModelo.get('clientId').enable();
    this.cadastroModelo.get('description').enable();
    this.cadastroModelo.get('author').enable();
    this.buttonDisable = false;
  }

  desabilitarForm() {
    this.cadastroModelo.get('namespace').disable();
    this.cadastroModelo.get('name').disable();
    this.cadastroModelo.get('prefix').disable();
  }

  desabilitarObrigatorios() {
    this.cadastroModelo.get('author').disable();
    this.cadastroModelo.get('description').disable();
  }

  getClienteById(id: number) {
    this.clienteService.getClienteUnico(id).subscribe(
      (data) => {
        this.clientId = data;
        console.log(this.clientId);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getPermissionCliente(idClient) {
    this.authorityArray = [];
    this.clientId;
    // console.log(this.clientId);
    this.permissoesService.getPermissionEmpresa(idClient).subscribe(
      (data: any[]) => {
        // verifica se nenhuma permissão foi encontrada
        this.authorityArray = data.map((el) => el.authority);
        const itensPermissoes = [
          'ATIVAR_DESATIVAR_MODELO',
          'EDIT_MODELO',
          'SUPER_USER',
        ];
        if (
          !itensPermissoes.some(
            (e) => this.authorityArray.includes(e),
            this.habilitarForm()
          )
        ) {
          this.desabilitarForm();
          this.desabilitarObrigatorios();
          this.buttonDisable = true;
          return this.openSnackBar(
            'Você não tem as permissões necessárias',
            true
          );
        }
        this.getAuthority();
      },
      (err) => {
        console.error(err);
        this.openSnackBar('Ocorreu um erro, tente novamente mais tarde', true);
      }
    );
  }

  getAuthority() {
    this.authorityArray.includes('SUPER_USER') ? (this.superUser = true) : null;
    this.authorityArray.includes('ADD_MODELO') ? (this.addModelo = true) : null;
  }

  salvarEditar(clientId) {
    if (this.cadastroModelo.valid) {
      if (!this.novoModelo) {
        this.habilitarForm();
        this.editSubmit();
      } else {
        if (this.addModelo || this.superUser) {
          this.onSubmit();
        } else {
          this.openSnackBarError(' Você não tem as permissões necessárias ! ');
        }
      }
    } else {
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }
  }
  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['info-snackbar'] : ['success-snackbar'],
    });
  }

  onChangeClient(e) {
    this.getPermissionCliente(e);
    console.log(e);
  }
}



// WEBPACK FOOTER //
// /app/src/app/importar-modelo/manter-model/manter-model.component.ts